export default __webpack_public_path__ + "static/media/cups-gl.269234af.png";